"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.financialStartYearForDate = exports.FER_BEGIN_YEARS = exports.setFinancialStartYear = void 0;
const turf_1 = require("@turf/turf");
const setFinancialStartYear = (segments, year) => (0, turf_1.featureCollection)(segments.features.map((feature) => {
    const { status, financial_start_year } = feature.properties;
    if (status !== 'registered' || financial_start_year) {
        return feature;
    }
    return {
        ...feature,
        properties: {
            ...feature.properties,
            financial_start_year: year,
        },
    };
}));
exports.setFinancialStartYear = setFinancialStartYear;
exports.FER_BEGIN_YEARS = [
    2013,
    2018,
    2023,
    ...[...Array(Math.floor((2100 - 2026) / 5) + 1)].map((_, i) => 2026 + i * 5),
];
/*
    The first year for which we can get financial is the current year if a VER is
    submitted before June 30th - unless it's the first year in a mandatory emissions
    reporting cycle, in which case it's the next year.
    REF: https://www.mpi.govt.nz/forestry/forestry-in-the-emissions-trading-scheme/emissions-returns-and-carbon-units-nzus-for-forestry/emissions-returns-in-the-emissions-trading-scheme-ets/emissions-returns-and-mandatory-emissions-return-periods-in-the-ets/
  */
const financialStartYearForDate = (date) => {
    const year = date.getFullYear();
    // Month is 0-indexed
    if (!exports.FER_BEGIN_YEARS.includes(year) && date.getMonth() < 6) {
        return year;
    }
    return year + 1;
};
exports.financialStartYearForDate = financialStartYearForDate;
